import "./SearchResultIllustration.scss";

export default {
  root: "im-search-result-illustration",
};
